import React from "react";
import { useLocation } from "react-router-dom";
import {
	HomeOutlined,
	CopyrightOutlined,
	FolderOpenOutlined,
	TeamOutlined,
	VideoCameraOutlined,
	SolutionOutlined,
	UserOutlined,
	LogoutOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Button } from "antd";
import { Link } from "react-router-dom";
import './Main.css';
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../UserContext";

const { Header, Footer, Sider } = Layout;
const App = ({ children }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const { handleLogout } = useContext(UserContext);
	const defaultSelectedKeys = () => {
		const pathname = location.pathname;
		const menuItems = [
			"/teacher/home",
			"/teacher/mycourse",
			"/teacher/courses",
			"/teacher/analytics",
			"/teacher/help",
		];

		const index = menuItems.findIndex((item) => pathname.includes(item));
		return index !== -1 ? [String(index + 1)] : ["2"];
	};

	const Logout = () => {
		handleLogout();
		navigate("/");
	};

	return (
		<Layout>
			<Sider
				className="side"
				breakpoint="md"
				collapsedWidth="0"
				style={{
					overflow: "auto",
					height: "100vh",
					position: "fixed",
					left: 0,
					top: "80px",
					bottom: 0,
					zIndex: 1,
					background: "var(--color-primary)",
					color: "white",
				}}>
				<div className="demo-logo-vertical"></div>
				<Menu
					mode="inline"
					theme="dark"
					defaultSelectedKeys={defaultSelectedKeys()}
					className="menu">
					<Menu.Item key="1" icon={<HomeOutlined />} className="menu-home">
						<Link to="/teacher/home">Home</Link>
					</Menu.Item>
					<Menu.Item key="2" icon={<VideoCameraOutlined />}>
						<Link to="/teacher/mycourses">My Courses</Link>
					</Menu.Item>
					<Menu.Item key="3" icon={<VideoCameraOutlined />}>
						<Link to="/teacher/courses">Create Course</Link>
					</Menu.Item>
					<Menu.Item key="4" icon={<FolderOpenOutlined />}>
						<Link to="/teacher/analytics">Analytics</Link>
					</Menu.Item>
					
					<Menu.Item key="5" icon={<CopyrightOutlined />}>
						<Link to="/teacher/help">Help</Link>
					</Menu.Item>
					
				</Menu>
			</Sider>
			<Layout>
				<Header className="head">
					<div className="title">LEARN YOUR WAY</div>
					<div
						style={{ display: "flex", alignItems: "center" }}
						className="head-icons">
						<Button type="text" onClick={Logout}>
							<LogoutOutlined />
						</Button>
					</div>
				</Header>
				<div className="content">{ children }</div>
				
			</Layout>
		</Layout>
	);
};
export default App;
